import { UTCDate } from '@date-fns/utc';
import { format, getTime } from 'date-fns';
import { TransactionView } from '../../types/entity-types';

const TODAY = format(new UTCDate(), 'yyyy-MM-dd');

type GetFxRatesDateRangeParams = {
  transactions?: TransactionView[];
};

export const getFxRatesDateRange = ({ transactions }: GetFxRatesDateRangeParams) => {
  if (!transactions || transactions.length === 0) {
    // If there are no transactions, we should still return a start and end date to avoid issues with the data-provider
    return {
      startDate: TODAY,
      endDate: TODAY,
    };
  }

  // Sorted by oldest transaction first
  const sortedTransactions = transactions.sort((a, b) => getTime(a.fspDate) - getTime(b.fspDate));

  const startDate = format(new UTCDate(sortedTransactions[0].fspDate), 'yyyy-MM-dd');
  // We need today's date because the account balances should be converted to today's fx rate
  const endDate = TODAY;

  return {
    startDate,
    endDate,
  };
};
